// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2YPHo","detailsBorder":"styles_detailsBorder__1NumQ"};